import { AuthState, AuthStateLoginStatus } from '../../types/auth';
import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SetAuthIdentityPayload } from '../../types/auth-state';

const initialState: AuthState = {
  authContext: null,
  isOwner: false,
  loginStatus: AuthStateLoginStatus.NONE,
  // lastLoginStatus is to determine if user's auth status has changed
  lastLoginStatus: AuthStateLoginStatus.NONE, 
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthIdentity: (state, action: PayloadAction<SetAuthIdentityPayload>) => {
      state.authContext = action.payload.identity;
      state.loginStatus = action.payload.loginStatus;
      if ([AuthStateLoginStatus.AUTHENTICATED, AuthStateLoginStatus.NOT_AUTHENTICATED].includes(action.payload.loginStatus)) {
        state.lastLoginStatus = action.payload.loginStatus;
      }
      state.isOwner = action.payload.isOwner;
    },
    unsetAuthIdentity: (state) => {
      state.authContext = null;
      state.loginStatus = AuthStateLoginStatus.NOT_AUTHENTICATED;
      state.lastLoginStatus = AuthStateLoginStatus.NOT_AUTHENTICATED;
      state.isOwner = false;
    },
  },
});

export const { setAuthIdentity, unsetAuthIdentity } =
  authSlice.actions;

export const onAuthInit = createAction('auth/onAuthInit');

export const onAuthChange = createAction('auth/onAuthChange');

export const onAuthLogin = createAction('auth/onAuthLogin');

export const onAuthLogout = createAction('auth/onAuthLogout');

export default authSlice.reducer;
